import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  RequestOwnPasswordDTO,
  RequestPasswordDTO,
  ResponsePasswordDTO,
  SearchOperationDto,
} from '../model/users-model';
import { environment } from '@env/environment';
import { OperationsDto } from '@app/requests/model/requests-model';

@Injectable({
  providedIn: 'root',
})
export class UsersApiService {
  constructor(private _http: HttpClient) {}

  postSearchOperation(searchOperationDto: SearchOperationDto): Observable<OperationsDto[]> {
    return this._http.post<OperationsDto[]>(
      environment.URL_BASE_ADMIN + environment.subUrlSearchOperation,
      searchOperationDto
    );
  }

  postSetOtherPassword(user: RequestPasswordDTO): Observable<ResponsePasswordDTO> {
    return this._http.post<ResponsePasswordDTO>(environment.URL_BASE_ADMIN + environment.subUrlSetOtherPassword, user);
  }

  postSetOwnPassword(request: RequestOwnPasswordDTO): Observable<RequestOwnPasswordDTO> {
    return this._http.post<RequestOwnPasswordDTO>(
      environment.URL_BASE_ADMIN + environment.subUrlSetOwnPassword,
      request
    );
  }
}
